import type { ChatError } from '../models';
import { AgentChatError } from '../models';

export function toError(e: unknown): ChatError {
  if (e instanceof AgentChatError) {
    return { message: e.message, statusCode: e.statusCode };
  }
  const message = e instanceof Error ? e.message : 'エージェントの応答に失敗しました';
  return { message, statusCode: 0 };
}
